import { AlertOption, alertStatus } from './command.models';
import _ from 'lodash';
import moment from 'moment';

export default function CommandService(
  CommandsRepo,
  equipmentDetailsService,
  $filter,
  gettext,
  gettextCatalog,
) {
  'ngInject';

  const service = {
    packageCommandsConfig: packageCommandsConfig,
    getHealthStatus: getHealthStatus,
    healthStatusTypes: alertStatus,
    getEquipmentSeries: getEquipmentSeries,
  };

  function packageCommandsConfig(equipmentId) {
    return CommandsRepo.getCommandsForEquipment(equipmentId).then(function (response) {
      return response.data;
    });
  }

  const translateText = (text, params = {}) => gettextCatalog.getString(text, params);

  const alertDefaultOptions = [
    {
      name: gettext('Communication'),
      class: 'fa-exchange',
      calcStatus: function (equipment) {
        const result = {};

        if (equipment.communicatedAt) {
          const range = moment.range(equipment.communicatedAt, moment().toDate());
          if (range.diff('hours', false) > 2) {
            result.status = alertStatus.error;
            result.text = gettext(
              'No communication has been made with the equipment in the last 2 hours. The device last communicated on {{c_date}}.',
            );
            result.textParams = {
              c_date: $filter('TableDateFilter')(moment(equipment.communicatedAt)),
            };
          } else {
            result.status = alertStatus.good;
            result.text = gettext('The equipment last communicated {{minutes}} minutes ago.');
            result.textParams = { minutes: range.diff('minutes') };
          }
        } else {
          result.status = alertStatus.error;
          result.text = gettext(
            'No communication has ever been made with the equipment {{text}}. Please ensure the installation process completed successfully.',
          );
        }

        return result;
      },
    },
  ];

  let statusAlertOptions = alertDefaultOptions;

  function getHealthStatus(equipmentSeries, apicontrolsStatus = null) {
    statusAlertOptions =
      apicontrolsStatus == null
        ? statusAlertOptions
        : alertDefaultOptions.concat(
            (apicontrolsStatus || []).map((controlstatus) => new AlertOption(controlstatus)),
          );

    let alerts = [];
    _.forEach(statusAlertOptions, function (alertOption) {
      const alert = {};
      const status = alertOption.calcStatus(equipmentSeries);

      alert.name = translateText(alertOption.name);
      alert.class = alertOption.class;
      alert.status = status.status;
      alert.text = translateText(status.text, status.textParams);
      alerts.push(alert);
    });
    return alerts;
  }

  function getEquipmentSeries(equipmentId) {
    return equipmentDetailsService.get(equipmentId, ['series']);
  }

  return service;
}
